import * as UpdateJuridicalPersonTypes from 'src/actions/juridical-person/update/Types';
import { UpdateJuridicalPersonAction } from 'src/actions/juridical-person/update/UpdateJuridicalPerson.actions';

export interface UpdateJuridicalPersonState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: UpdateJuridicalPersonState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function UpdateJuridicalPersonReducer(state: UpdateJuridicalPersonState = initialState,
                                             action: UpdateJuridicalPersonAction): UpdateJuridicalPersonState {
  switch (action.type) {
    case UpdateJuridicalPersonTypes.UPDATE_JURIDICAL_PERSON_ATTEMPT:
      return {...state, loading: true, error: false};
    case UpdateJuridicalPersonTypes.UPDATE_JURIDICAL_PERSON_SUCCESS:
      return {...state, loading: false, error: false};
    case UpdateJuridicalPersonTypes.UPDATE_JURIDICAL_PERSON_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/juridical-person/UpdateJuridicalPersonReducer.tsx